import React from 'react';
import { Box, Flex, TextV2, TooltipV2 } from '@withjoy/joykit';
import { Info } from '@withjoy/joykit/icons';
import { FilterFacet } from '@apps/stays/components/filters/FilterFacet';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

interface JoyTravelBenefitsFacetProps {
  isCUGChecked: boolean;
  onCUGToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
  title: string;
}

export const JoyTravelBenefitsFacet: React.FC<JoyTravelBenefitsFacetProps> = ({ isCUGChecked, onCUGToggle, title }) => {
  const { t } = useTranslation('accommodationsConsole');
  const filtersPanelTrans = t('filterPanel');

  return (
    <FilterFacet title={title}>
      <Flex
        flexDirection="column"
        gap={5}
      >
        <StyledCheckboxV2
          isChecked={isCUGChecked}
          onChange={onCUGToggle}
          id="cug-rates"
        >
          <Flex
            alignItems="center"
            gap={2}
            color="mono14"
          >
            <TextV2 typographyVariant="body1">{filtersPanelTrans.joyTravelBenefits.closedUserGroupRates()}</TextV2>
            <TooltipV2
              overrides={{
                Content: { props: { paddingY: 4, paddingLeft: pxToRem(14), paddingRight: 4, borderRadius: pxToRem(12), color: 'white', marginLeft: 2 } },
              }}
              content={
                <Flex
                  flexDirection="column"
                  maxWidth={pxToRem(300)}
                >
                  <Box typographyVariant="label3">{filtersPanelTrans.joyTravelBenefits.closedUserGroupRates()}</Box>
                  <Box
                    typographyVariant="label2"
                    color="mono4"
                  >
                    {filtersPanelTrans.joyTravelBenefits.closedUserGroupRatesTooltipContent()}
                  </Box>
                </Flex>
              }
              placement="top"
              onMouseEnterDelay={500}
            >
              <Info size={16} />
            </TooltipV2>
          </Flex>
        </StyledCheckboxV2>
      </Flex>
    </FilterFacet>
  );
};
